export enum AttachmentDialogTypesEnum {
  IMAGE = 'image',
  TEXT = 'text',
  DATA_TABLE = 'data-table',
  URL = 'url',
  REF_MODEL_NODE = 'refModelNode',
  ORG_MODEL_NODE = 'orgModelNode',
  REQUIREMENT = 'requirement',
  STORY = 'story'
}

export enum TreeStoreItemsEnum {
  SELECTED_NODE = 'selectedNode',
  UPDATE_NODE_IN_TREE = 'updateNodeInTree',
  UPDATE_CHILDREN_NODES_IN_TREE = 'updateChildrenNodesInTree'
}

export enum OUTCOME {
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete'
}
